import { ChangeEvent, forwardRef, Ref } from "react";

import NumberInputWrapper from "./NumberInputWrapper";

import { ToggleDirection } from "./constants";
import { FieldTypes } from "../../formik-form-components/FormikFormLine/constants";
import * as styledElements from "./NumberInputStyles";

const NumberInput = (
  {
    value,
    name,
    disabled,
    min,
    max,
    onChange,
    toggleOnly = false,
    isSmallSize = false,
    autoFocus,
  }: {
    value: number;
    name?: string;
    disabled?: boolean;
    min?: number;
    max?: number;
    onChange: (newValue: number) => void;
    toggleOnly?: boolean;
    isSmallSize?: boolean;
    autoFocus?: boolean;
  },
  ref: Ref<HTMLInputElement> | null,
) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(parseFloat(e.target.value));
  };

  const handleToggle = (direction: ToggleDirection) => {
    onChange(direction == ToggleDirection.UP ? value + 1 : value - 1);
  };

  return (
    <NumberInputWrapper
      disabled={disabled}
      handleToggle={handleToggle}
      isSmallSize={isSmallSize}
    >
      <styledElements.Input
        ref={ref}
        min={min}
        max={max}
        name={name}
        type={FieldTypes.number}
        value={value}
        disabled={disabled || toggleOnly}
        onChange={handleChange}
        autoFocus={autoFocus}
      />
    </NumberInputWrapper>
  );
};

export default forwardRef(NumberInput);
